// @flow
import {
  Button,
  CircularProgress,
  CssBaseline,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from "react-i18next";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css'

import firebase, { authInstance } from '../../firebase';

const styles = theme => {
  return {
    form: {
      marginTop: 4,
      width: "100%", // Fix IE 11 issue.
    },
    message: {
      margin: "12px 0 16px",
    },
    paper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 32,
      maxWidth: 420,
    },
    phoneInput: {
      '&:focus': {
        borderColor: `${theme.palette.ava.blue} !important`,
        boxShadow: `0 0 0 1px ${theme.palette.ava.blue} !important`
      },
      fontFamily: "inherit !important",
      width: "100% !important",
      height: 56,
    },
    phoneInputWrap: {
      fontFamily: "inherit",
      width: "100%",
    },
    submit: {
      boxShadow: 'none',
      color: "white",
      margin: '12px 0 8px',
    },
    title: {
      fontWeight: 700,
    }
  }
};

type Props = {
  classes: Object,
  handleNewlyLoggedInUser: Function,
  t: Function
}

type State = {
  code: string,
  invalidCode: boolean,
  invalidPhoneNumber: boolean,
  message: string,
  phone: string,
  loading: boolean,
  step: number
}

class ScribeLoginPhone extends React.Component<Props, State> {
  recaptchaVerifier;

  constructor(props: Props) {
    super(props);
    this.state = {
      code: '',
      invalidCode: false,
      invalidPhoneNumber: false,
      message: "inputPhone",
      phone: '',
      loading: false,
      step: 0,
    };
  }

  componentDidMount() {
    authInstance.useDeviceLanguage();
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("sign-in-button", {
      "size": "invisible",
    });
  }

  async sendVerificationCode(event) {
    event.preventDefault();
    const { phone } = this.state;
    const appVerifier = window.recaptchaVerifier;
    this.setState({ loading: true });
    authInstance.signInWithPhoneNumber(`+${phone}`, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        this.setState({
          invalidPhoneNumber: false,
          loading: false,
          message: "inputCode",
          step: 1
        })
      }).catch((e) => {
        if (e.code === "auth/invalid-phone-number") {
          this.setState({
            invalidPhoneNumber: true,
            loading: false,
            message: "invalidPhoneNumber"
           });
          console.error(e);
        } else {
          this.setState({ loading: false });
          console.error(e);
        }
    });
  }

  async confirmVerificationCode(event) {
    event.preventDefault();
    const { code } = this.state;
    this.setState({ loading: true });
    window.confirmationResult.confirm(code).then(async result => {
      const { user } = result;
      const { handleNewlyLoggedInUser } = this.props
      await authInstance.setPersistence("local");
      if (user) {
        this.setState({ loading: true });
        handleNewlyLoggedInUser(user);
      }
    }).catch(e => {
      if (e.code === "auth/invalid-verification-code") {
        this.setState({
          invalidCode: true,
          loading: false,
          message: "invalidCode",
         });
        console.error(e);
      } else {
        this.setState({ loading: false });
        console.error(e);
      }
    });
  }

  render() {
    const { classes, t } = this.props;
    const {
      loading,
      invalidCode,
      invalidPhoneNumber,
      message,
      step,
      phone,
      code,
    } = this.state;

    return (
      <div>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography variant="h4" className={classes.title} gutterBottom>
            {t("signIn")}
          </Typography>
          <Typography
            variant="body1"
            className={classes.message}
            align="center"
            color={(invalidPhoneNumber || invalidCode) ? "error" : "initial"}
            >
            {t(`signin-messages.${message}`)}
          </Typography>
          <form
            className={classes.form}
            noValidate
          >
            {step === 0 && (
              <PhoneInput
                country="us"
                value={phone}
                onChange={phoneNumber => this.setState({ phone: phoneNumber })}
                containerClass={classes.phoneInputWrap}
                inputClass={classes.phoneInput}
                isValid={!invalidPhoneNumber}
                defaultErrorMessage="Invalid phone number"
                />
            )}
            {step === 1 && (
              <TextField
                variant="outlined"
                margin="none"
                required
                fullWidth
                name="code"
                label="Code"
                type="number"
                id="code"
                autoFocus
                autoComplete="none"
                value={code || ""}
                onChange={(event) =>
                  this.setState({ code: event.target.value })
                }
                error={invalidCode}
              />
            )}
            {step === 0 && (
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                id="sign-in-button"
                disabled={loading}
                onClick={(event) => this.sendVerificationCode(event)}
              >
                {loading && <CircularProgress color="secondary" size="1.6em" />}
                {!loading && t("continue")}
              </Button>
            )}
            {step === 1 && (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={(event) => this.confirmVerificationCode(event)}
                disabled={code.length !== 6 || loading}
              >
                {loading && <CircularProgress color="secondary" size="1.6em" />}
                {!loading && t("signIn")}
              </Button>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(ScribeLoginPhone));
